<template>
  <div class="mui-layout__collection--zero">
    <h3>{{title}}</h3>
    <p>{{message}}</p>
  </div>
</template>

<script>
export default {
  name: 'RecipeCollectionZeroState',
  props: {
    message: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Recipe/CollectionZeroState.vue